// Trabajos más comunes: un toque y queda escrito (10-oct-2026). Los usan la carga por N/S
// (clientes mensuales) y la tarjeta "Equipo N" del ticket, de admin y técnico (21-oct-2026).
export const TRABAJOS_FRECUENTES = ['Instalación', 'Sanitización', 'Cambio de filtro', 'Limpieza general', 'Cambio de canilla',
    'Retiro del equipo',
    'Reparación de pérdida', 'Cambio de termostato', 'Revisión sin falla'];

const partes = (texto) => String(texto || '').split(/\s*[·,]\s*/).map(x => x.trim()).filter(Boolean);

/** Suma el trabajo al texto, o lo saca si ya estaba ("Sanitización · Cambio de filtro"). */
export const sumarTrabajo = (texto, t) => {
    const p = partes(texto);
    return (p.includes(t) ? p.filter(x => x !== t) : [...p, t]).join(' · ');
};
export const tieneTrabajo = (texto, t) => partes(texto).includes(t);
